export const filteredHousesRegistration = (houses) => {
  const objHouses = {};

  houses.forEach((house) => {
    if (house.streetId in objHouses) {
      objHouses[house.streetId].push(house);
    } else {
      objHouses[house.streetId] = [house]
    }
  })
  return objHouses;
}